import PropTypes from 'prop-types';
import React from 'react';

function RadioGroup(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      name = _ref.name;
  return /*#__PURE__*/React.createElement("div", {
    id: name,
    "aria-label": ariaLabel,
    role: "radiogroup"
  }, children.map(
  /* istanbul ignore next */
  function (child, i) {
    return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
      name: name,
      key: "radio-" + name + "-" + i
    }) : child;
  }));
}

RadioGroup.propTypes = {
  /** name property that gets passed on to the inputs. Should be similar to a variable name (i.e. creditCardChoices) */
  name: PropTypes.string.isRequired,

  /** Radio group's label to be read by screen readers */
  ariaLabel: PropTypes.string.isRequired
};
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map